/* Carte Blanche 1:1 LP クイックビュー(ポップアップ)＋非同期カート追加＋画面下カートバー
   ------------------------------------------------------------------------------------
   ・対象商品カード(画像/商品名/「詳しく見る」= [data-ns1-open])のクリックでポップアップを開く。
     商品ページへは遷移しない(クリックを横取りして preventDefault)。「商品ページへ」リンクのみ通常遷移。
   ・ポップアップ内: 画像・説明・価格・「もう1本無料」訴求・数量設定・カートに入れる・商品ページへ。
   ・カート追加は /cart/add.js で非同期(ページ遷移なし)。追加後もポップアップは開いたまま完了表示。
   ・画面下の常設バーに「カートに◯本／＋無料◯本(合計◯本お届け)／カートを見る・お会計へ」をリアルタイム表示。
     無料本数 = カート内の 1to1 対象商品の数量合計(1本購入につき1本無料の1:1)。
   ・カートはページ種別が「ページ遷移型」でもこのページ内で完結。ヘッダーのカート数も自動更新。
   ・JS無効/失敗時は [data-ns1-open] が素のリンクとして商品ページへ遷移(内容は死なない)。
   ・テーマエディタの再描画に強いよう、クリックは document への委譲。多重初期化はフラグで防ぐ。 */
(function () {
  'use strict';
  if (window.__ns1QuickviewInit) return;
  window.__ns1QuickviewInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');
  var ADD_URL = BASE + '/cart/add.js';
  var CART_URL = BASE + '/cart.js';
  var CART_PAGE = BASE + '/cart';

  var oneToOneIds = new Set();
  function loadIds() {
    oneToOneIds = new Set();
    var el = document.getElementById('ns1-1to1-ids');
    if (el) {
      try {
        JSON.parse(el.textContent || '[]').forEach(function (id) { oneToOneIds.add(Number(id)); });
      } catch (e) { /* JSONが壊れていても下のカード走査で補う */ }
    }
    document.querySelectorAll('[data-ns1-card][data-product-id]').forEach(function (c) {
      oneToOneIds.add(Number(c.getAttribute('data-product-id')));
    });
  }

  // ---- DOM参照(buildUI後にセット) ----
  var overlay, panel, els = {}, bar = {}, lastFocus = null, currentVariant = null, currentAvailable = false;

  function h(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }

  function buildUI() {
    // ===== ポップアップ =====
    overlay = h('div', 'ns1-qv-overlay', { 'data-ns1-overlay': '', 'hidden': '' });
    panel = h('div', 'ns1-qv ns-lp-root', { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'ns1-qv-title', tabindex: '-1' });
    panel.innerHTML =
      '<button type="button" class="ns1-qv__close" data-ns1-close aria-label="閉じる"><span aria-hidden="true">×</span></button>' +
      '<div class="ns1-qv__body">' +
        '<div class="ns1-qv__media" data-ns1-media></div>' +
        '<div class="ns1-qv__main">' +
          '<h3 class="ns1-qv__title" id="ns1-qv-title" data-ns1-title></h3>' +
          '<div class="ns1-qv__pricerow"><span class="ns1-qv__price" data-ns1-price></span><span class="ns1-qv__bonus" data-ns1-bonus hidden></span></div>' +
          '<div class="ns1-qv__desc" data-ns1-desc></div>' +
          '<div class="ns1-qv__buy" data-ns1-buy>' +
            '<div class="ns1-qv__qty">' +
              '<button type="button" class="ns1-qv__step" data-ns1-dec aria-label="数量を1減らす">−</button>' +
              '<input class="ns1-qv__qtyinput" data-ns1-qty type="number" min="1" step="1" value="1" inputmode="numeric" aria-label="数量">' +
              '<button type="button" class="ns1-qv__step" data-ns1-inc aria-label="数量を1増やす">＋</button>' +
            '</div>' +
            '<button type="button" class="ns1-qv__add" data-ns1-add>カートに入れる</button>' +
          '</div>' +
          '<p class="ns1-qv__soldout" data-ns1-soldout hidden>申し訳ございません。この商品は現在ご購入いただけません。</p>' +
          '<p class="ns1-qv__feedback" data-ns1-feedback role="status" aria-live="polite" hidden></p>' +
          '<a class="ns1-qv__pdp" data-ns1-pdp href="#">商品ページへ</a>' +
          '<button type="button" class="ns1-qv__closebottom" data-ns1-close>閉じる</button>' +
        '</div>' +
      '</div>';
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    els.media = panel.querySelector('[data-ns1-media]');
    els.title = panel.querySelector('[data-ns1-title]');
    els.price = panel.querySelector('[data-ns1-price]');
    els.bonus = panel.querySelector('[data-ns1-bonus]');
    els.desc = panel.querySelector('[data-ns1-desc]');
    els.buy = panel.querySelector('[data-ns1-buy]');
    els.qty = panel.querySelector('[data-ns1-qty]');
    els.add = panel.querySelector('[data-ns1-add]');
    els.soldout = panel.querySelector('[data-ns1-soldout]');
    els.feedback = panel.querySelector('[data-ns1-feedback]');
    els.pdp = panel.querySelector('[data-ns1-pdp]');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    panel.querySelectorAll('[data-ns1-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    panel.querySelector('[data-ns1-dec]').addEventListener('click', function () { stepQty(-1); });
    panel.querySelector('[data-ns1-inc]').addEventListener('click', function () { stepQty(1); });
    els.qty.addEventListener('change', function () { els.qty.value = normQty(els.qty.value); });
    els.add.addEventListener('click', onAdd);

    // ===== 画面下カートバー =====
    var b = h('div', 'ns1-cartbar ns-lp-root', { 'data-ns1-cartbar': '', 'hidden': '' });
    b.innerHTML =
      '<div class="ns1-cartbar__info">' +
        '<span class="ns1-cartbar__count">カートに<b data-ns1-bar-paid>0</b>本</span>' +
        '<span class="ns1-cartbar__free" data-ns1-bar-freewrap hidden>＋無料<b data-ns1-bar-free>0</b>本<span class="ns1-cartbar__total">(合計<b data-ns1-bar-total>0</b>本お届け)</span></span>' +
      '</div>' +
      '<a class="ns1-cartbar__btn" data-ns1-bar-link href="' + CART_PAGE + '">カートを見る・お会計へ</a>';
    document.body.appendChild(b);
    bar.root = b;
    bar.paid = b.querySelector('[data-ns1-bar-paid]');
    bar.freewrap = b.querySelector('[data-ns1-bar-freewrap]');
    bar.free = b.querySelector('[data-ns1-bar-free]');
    bar.total = b.querySelector('[data-ns1-bar-total]');
  }

  function normQty(val) {
    var n = parseInt(val, 10);
    if (!n || n < 1) n = 1;
    if (n > 99) n = 99;
    return n;
  }
  function stepQty(d) { els.qty.value = normQty(parseInt(els.qty.value, 10) + d); }

  // ---- ポップアップを開く ----
  function openFromCard(card) {
    if (!overlay) buildUI();
    resetFeedback();
    var title = card.getAttribute('data-title') || '';
    var price = card.getAttribute('data-price') || '';
    var compare = card.getAttribute('data-compare') || '';
    var bonus = card.getAttribute('data-bonus') || '';
    var url = card.getAttribute('data-url') || '#';
    currentVariant = card.getAttribute('data-variant-id') || '';
    currentAvailable = card.getAttribute('data-available') === '1';

    els.title.textContent = title;
    els.price.innerHTML = '';
    var nowEl = h('span', 'ns1-qv__now'); nowEl.textContent = price; els.price.appendChild(nowEl);
    if (compare) { var wasEl = h('span', 'ns1-qv__was'); wasEl.textContent = compare; els.price.appendChild(wasEl); }
    if (bonus) { els.bonus.textContent = bonus; els.bonus.hidden = false; } else { els.bonus.hidden = true; }
    els.pdp.href = url;
    els.qty.value = 1;

    // 画像・説明を <template> から取り込む(この瞬間に初めて読み込まれる)
    fillDetail(card);

    // 在庫
    if (currentAvailable && currentVariant) {
      els.buy.hidden = false; els.soldout.hidden = true; els.add.disabled = false;
    } else {
      els.buy.hidden = true; els.soldout.hidden = false;
    }

    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.documentElement.classList.add('ns1-qv-open');
    document.addEventListener('keydown', onKey, true);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); panel.focus(); });
  }

  function fillDetail(card) {
    els.media.innerHTML = '';
    els.desc.innerHTML = '';
    var tpl = card.querySelector('template[data-ns1-detail]');
    if (!tpl) { els.media.innerHTML = '<div class="ns1-qv__noimg">画像準備中</div>'; return; }
    var frag = tpl.content.cloneNode(true);
    var imgs = [].slice.call(frag.querySelectorAll('.ns1-qv__srcimg'));
    var items = imgs.map(function (im) {
      return { src: im.getAttribute('src'), narrow: im.classList.contains('is-narrow') };
    }).filter(function (it) { return it.src; });
    buildGallery(items);
    var descSrc = frag.querySelector('.ns1-qv__descsrc');
    if (descSrc && descSrc.innerHTML.trim()) els.desc.innerHTML = descSrc.innerHTML;
    else els.desc.innerHTML = '<p class="ns1-qv__nodesc">この商品の詳しい説明は商品ページでご覧いただけます。</p>';
  }

  function thumbSrc(src) {
    // Shopify CDN画像は width パラメータでサムネを軽量化
    if (/\/cdn\//.test(src) || /width=/.test(src)) {
      return src.replace(/([?&])width=\d+/, '$1width=160');
    }
    return src;
  }

  function buildGallery(items) {
    if (!items.length) { els.media.innerHTML = '<div class="ns1-qv__noimg">画像準備中</div>'; return; }
    var main = h('img', 'ns1-qv__mainimg' + (items[0].narrow ? ' is-narrow' : ''));
    main.src = items[0].src; main.alt = els.title.textContent;
    els.media.appendChild(main);
    if (items.length > 1) {
      var strip = h('div', 'ns1-qv__thumbs');
      items.forEach(function (item, i) {
        var btn = h('button', 'ns1-qv__thumb' + (i === 0 ? ' is-active' : ''), { type: 'button', 'aria-label': '画像' + (i + 1) });
        var t = h('img', item.narrow ? 'is-narrow' : ''); t.src = thumbSrc(item.src); t.alt = '';
        btn.appendChild(t);
        btn.addEventListener('click', function () {
          main.src = item.src; main.removeAttribute('srcset');
          main.classList.toggle('is-narrow', !!item.narrow);
          strip.querySelectorAll('.ns1-qv__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        strip.appendChild(btn);
      });
      els.media.appendChild(strip);
    }
  }

  function closeModal() {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    document.documentElement.classList.remove('ns1-qv-open');
    var done = function () {
      overlay.hidden = true;
      overlay.removeEventListener('transitionend', done);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    };
    overlay.addEventListener('transitionend', done);
    setTimeout(done, 320); // transition非対応の保険
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
    if (e.key === 'Tab') { trapFocus(e); }
  }

  function trapFocus(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    f = [].slice.call(f).filter(function (el) { return el.offsetParent !== null || el === panel; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function resetFeedback() {
    if (!els.feedback) return;
    els.feedback.hidden = true;
    els.feedback.textContent = '';
    els.feedback.classList.remove('is-error', 'is-ok');
  }

  // ---- カート追加 ----
  function onAdd() {
    if (!currentVariant || els.add.disabled) return;
    var qty = normQty(els.qty.value);
    els.qty.value = qty;
    els.add.disabled = true;
    els.add.classList.add('is-loading');
    resetFeedback();
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(currentVariant), quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) {
        showFeedback((res.data && (res.data.description || res.data.message)) || 'カートに追加できませんでした。時間をおいて再度お試しください。', true);
        els.add.disabled = false; els.add.classList.remove('is-loading');
        return;
      }
      return refreshCart().then(function () {
        showFeedback('カートに追加しました。下のバーで本数をご確認いただけます。', false);
        els.add.disabled = false; els.add.classList.remove('is-loading');
      });
    }).catch(function () {
      showFeedback('通信エラーが発生しました。時間をおいて再度お試しください。', true);
      els.add.disabled = false; els.add.classList.remove('is-loading');
    });
  }

  function showFeedback(msg, isError) {
    if (!els.feedback) return;
    els.feedback.textContent = msg;
    els.feedback.classList.toggle('is-error', !!isError);
    els.feedback.classList.toggle('is-ok', !isError);
    els.feedback.hidden = false;
  }

  // ---- カート状態の取得と反映(ヘッダー数字＋画面下バー) ----
  function refreshCart() {
    loadIds();
    return fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateHeaderBubble(cart.item_count); updateBar(cart); })
      .catch(function () { /* 取得失敗時はバーを変更しない */ });
  }

  function updateHeaderBubble(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = h('div', 'cart-count-bubble');
        var sp = h('span', null, { 'aria-hidden': 'true' });
        bubble.appendChild(sp);
        link.appendChild(bubble);
      }
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = count < 100 ? count : '';
    } else if (bubble) {
      bubble.remove();
    }
  }

  function updateBar(cart) {
    if (!bar.root) return;
    var paid = cart.item_count || 0;
    var free = 0;
    (cart.items || []).forEach(function (it) {
      if (oneToOneIds.has(Number(it.product_id))) free += it.quantity;
    });
    bar.paid.textContent = paid;
    if (free > 0) {
      bar.free.textContent = free;
      bar.total.textContent = paid + free;
      bar.freewrap.hidden = false;
    } else {
      bar.freewrap.hidden = true;
    }
    if (paid > 0) {
      bar.root.hidden = false;
      requestAnimationFrame(function () { bar.root.classList.add('is-shown'); });
    } else {
      bar.root.classList.remove('is-shown');
      bar.root.hidden = true;
    }
  }

  // ---- カードから直接カートに入れる(数量1・ポップアップを開かない) ----
  function directAdd(btn) {
    var card = btn.closest && btn.closest('[data-ns1-card]');
    if (!card) return;
    if (card.getAttribute('data-available') !== '1') return;
    var vid = card.getAttribute('data-variant-id');
    if (!vid || btn.disabled) return;
    if (!overlay) buildUI(); // バー生成を保証
    var orig = btn.getAttribute('data-orig') || btn.textContent;
    btn.setAttribute('data-orig', orig);
    btn.disabled = true; btn.classList.add('is-loading');
    var revert = function () { btn.textContent = orig; btn.disabled = false; btn.classList.remove('is-loading', 'is-done'); };
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) { btn.textContent = '追加できませんでした'; btn.classList.remove('is-loading'); setTimeout(revert, 2200); return; }
      return refreshCart().then(function () {
        btn.textContent = 'カートに追加しました';
        btn.classList.remove('is-loading'); btn.classList.add('is-done');
        setTimeout(revert, 1800);
      });
    }).catch(function () { btn.textContent = '通信エラー'; btn.classList.remove('is-loading'); setTimeout(revert, 2200); });
  }

  // ---- クリック委譲(エディタ再描画後も有効) ----
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var addBtn = e.target.closest('[data-ns1-add-direct]');
    if (addBtn) { e.preventDefault(); directAdd(addBtn); return; }
    var trigger = e.target.closest('[data-ns1-open]');
    if (!trigger) return;
    var card = trigger.closest('[data-ns1-card]');
    if (!card) return; // 対象カード外なら通常遷移に任せる
    e.preventDefault();
    openFromCard(card);
  });

  function init() { loadIds(); buildUI(); refreshCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
